
export enum ApiEnum{
  Auth = 'auth',
  Password = 'password',
  Change = 'change',
  FoodModule ='foo-m',
  Food = 'food',
  FoodExtra = 'food-extra',
  RestaurantModule = 'rpo-m',
  Section = 'section',
  SectionTable = 'section-table',
  Order = 'order',
  MenuGroup = 'menu-group',
  OrderBill = 'order-bill',
  POS = 'pos',
  OrderStatus = 'order-status',
  SystemSetting = 'system-settings',
  TaxValue = 'tax-value',
  ServiceCharge = 'service-charge',
  RestaurantDetail = 'restaurant-detail',
  RestaurantTable= 'table',
  Cart = 'cart',
  GetAll = 'get-all',
  Delete = 'delete',
  CartStatus = 'cart-status',
  SignIn = 'sign-in',
  FoodItemSearchTag ='food-item-search-tag',
  FoodItemCategory = 'food-category',
  FoodType = 'food-type',
  ActivePos = 'active-pos',
  FoodItemQuantityTag = 'food-quantity-tag',
  FoodIngredient = 'food-ingredient',
  DashBoard = 'dashboard',
  OnGoingOrderCount = 'on-going-order-count',
  CreatedByOrderCount = 'created-by-order-count',
  RevenueProfit = 'revenue-profit',
  AppImage = 'app-image',
  FoodTemplate = 'food-template',
  TopSellingItems = 'top-selling-items',
  SectionRevenue = 'section-revenue',
  CustomerOrder = 'customer-order',
  OrderOwner = 'order-owner',
  FinancialModule = 'finance-m',
  DailyReconciliation = 'daily-reconciliation',
  Auto = 'auto',
  Kitchen = 'kitchen',
  Menu = 'menu',
  DailySession = 'daily-sessions',
  End = 'end',
  Start = 'start',
  Token = 'token',
  Refresh = 'refresh',
  Subscriptions = 'subscriptions',
  Tenant = 'tenant',
  Active = 'active',
  Today_Orders = 'today-orders',
  Table = 'table',
  MoveOrder = 'move-order',
  Me = 'me',
  Notification = 'notifications'

}
